import { render, staticRenderFns } from "./PageNotifications.vue?vue&type=template&id=02930179"
import script from "./PageNotifications.vue?vue&type=script&lang=js"
export * from "./PageNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports